import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Smartphone, X } from "lucide-react";

const KEY = "fh_install_dismissed";

export const InstallPrompt = () => {
  const [evt, setEvt] = useState(null);
  const [ios, setIos] = useState(false);
  const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
  useEffect(() => {
    if (standalone || localStorage.getItem(KEY)) return;
    const onPrompt = (e) => { e.preventDefault(); setEvt(e); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    const ua = window.navigator.userAgent;
    if (/iphone|ipad|ipod/i.test(ua) && !/crios|fxios/i.test(ua)) setIos(true);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, [standalone]);
  if (standalone || (!evt && !ios)) return null;
  const dismiss = () => { localStorage.setItem(KEY, "1"); setEvt(null); setIos(false); };
  const install = async () => { evt.prompt(); const r = await evt.userChoice; if (r.outcome === "accepted") dismiss(); };
  return (
    <div className="fixed inset-x-3 bottom-3 z-50 flex items-center gap-3 rounded-xl border border-border bg-card/95 p-3 shadow-lg backdrop-blur md:left-auto md:right-4 md:w-96" data-testid="install-prompt">
      <Smartphone className="h-6 w-6 shrink-0 text-primary" />
      <div className="min-w-0 flex-1 text-sm">
        <p className="font-semibold">FIT HOUSE'u telefona kur</p>
        <p className="text-xs text-muted-foreground">{ios ? "Safari'de Paylaş simgesine basıp \"Ana Ekrana Ekle\" seçin." : "Ana ekrandan uygulama gibi açılır, tam ekran çalışır."}</p>
      </div>
      {evt && <Button size="sm" onClick={install} data-testid="install-btn">Kur</Button>}
      <button type="button" onClick={dismiss} className="text-muted-foreground hover:text-foreground" aria-label="Kapat" data-testid="install-dismiss"><X className="h-4 w-4" /></button>
    </div>
  );
};
